// Player injury / concussion records -- iteration 146

export const INJURY_TYPES = ["general", "concussion"] as const;
export type InjuryType = (typeof INJURY_TYPES)[number];

/** Mandatory minimum stand-down for a concussion before return-to-play. */
export const CONCUSSION_STANDDOWN_DAYS = 21;

/** 156 -- common specific injury labels for the autocomplete. Free text is also
 * allowed; this just seeds suggestions. */
export const INJURY_TYPE_OPTIONS = [
  "Concussion",
  "Hamstring strain",
  "Ankle sprain",
  "Knee ligament (ACL/MCL)",
  "Shoulder dislocation",
  "Fracture",
  "Muscle strain",
  "Ligament tear",
  "Laceration",
  "Bruising/contusion",
] as const;

export interface PlayerInjuryPublic {
  id: string;
  player_id: string;
  type: InjuryType;
  injury_type: string | null; // 156 -- specific label
  injured_on: string; // YYYY-MM-DD
  earliest_return_on: string | null; // YYYY-MM-DD -- return-to-play estimate (concussion auto-computed)
  return_to_train_on: string | null; // 156 -- YYYY-MM-DD return-to-train estimate
  cleared_on: string | null; // null = still injured/out
  cleared_by: string | null;
  clearance_note_url: string | null; // 156 -- uploaded doctor's note
  event_id: string | null; // 156 -- where it occurred
  match_id: string | null;
  note: string | null;
  /** Derived: cleared_on is null. */
  active: boolean;
  /** 156 -- officially clear to play = cleared AND a clearance note on file. */
  clear_to_play: boolean;
  created_at: string;
}

export interface PlayerInjuriesResponse {
  player_id: string;
  injuries: PlayerInjuryPublic[];
}
